import React, {Fragment, useState} from "react";
import ModalOverlay from "../../../components/modal-overlay/modal-overlay";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import TextInput from "../../../components/enhanced-text-input/enhanced-text-input";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import "./modal-email.scss";
import {isEmail} from "../../../utils/validators";
import Margin from "canvas-core-react/lib/Margin";
import {useAppContext} from "../../../context/AppContext";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import IconCompleteIllustrative from "canvas-core-react/lib/IconCompleteIllustrative";
import TextBody from "canvas-core-react/lib/TextBody";
import {WealthService} from "../../../services";

const ModalEmail = ({onClose}) => {
    const [state, setState] = useState({
        email: "",
        errors: {},
    });

    const wealthService = new WealthService();

    const {
        changeItem: setContext,
        state: context,
        displayError,
    } = useAppContext();

    const changeItem = (item) => (input) => {
        const {error = {}, value = ""} = input;

        let values = {};

        setState((prevState) => ({
            ...prevState,
            [item]: value,
            ...values,
            errors: {...prevState.errors, [item]: error},
        }));
    };

    const emailChange = (event) => {
        const {value = ""} = event.target;

        const isValid = isEmail(value);

        const error = !isValid ? "E-Mail inválido" : "";

        changeItem("email")({value: value, error});
    };

    const validateEmail = () => {
        let subjectId = context.subjectId;
        let email = state.email;
        setContext({
            loading: true,
        });
        wealthService
            .validateEmail({
                subjectId,
                email,
            })
            .then((res) => {
                if (res.status === true) {
                    setContext({
                        isValidEmail: true,
                    });
                    onClose();
                }
                if (res.status === false) {

                    let invalid = "E-Mail ingresado es incorrecto";
                    let item = "email";
                    let values = {};

                    setState((prevState) => ({
                        ...prevState,
                        [item]: email,
                        ...values,
                        errors: {...prevState.errors, [item]: invalid},
                    }));
                }
            })
            .catch((error) => {
                displayError(error);
            });
        setContext({
            loading: false,
        });
    };

    return (
        <Fragment>
            <ModalOverlay className={"modal-content-email"}>
                <div id="title-container">
                    <Margin
                        xs={[0, 0, 24, 0]}
                        sm={[0, 0, 24, 0]}
                        md={[0, 0, 24, 0]}
                        lg={[0, 0, 24, 0]}
                    >
                        <TextHeadline component="div" className="modal__text" size="small">
                            Ingresa tu E-mail registrado, para poder validarlo
                        </TextHeadline>
                    </Margin>
                </div>
                <div className="textfield-container">
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 12, 0]}
                                sm={[0, 0, 12, 0]}
                                md={[0, 0, 12, 0]}
                                lg={[0, 0, 12, 0]}
                            >
                                <TextInput
                                    id="email"
                                    name="email"
                                    placeholder="ingresa tu email"
                                    label="Email:"
                                    value={state.email}
                                    onChange={emailChange}
                                    error={
                                        state.errors.email && state.errors.email.trim() !== ""
                                            ? true
                                            : false
                                    }
                                    errorMsg={state.errors.email}
                                />
                            </Margin>
                        </Column>
                    </Row>
                    {context.isValidEmail && (
                        <Row>
                            <Column>
                                <Margin
                                    xs={[0, 0, 24, 0]}
                                    sm={[0, 0, 24, 0]}
                                    md={[0, 0, 24, 0]}
                                    lg={[0, 0, 24, 0]}
                                >
                                    <div className="media">
                                        <div className="media-object">
                                            <IconCompleteIllustrative id="icon-complete"/>
                                        </div>
                                        <div className="media-content">
                                            <TextBody component="small">Tu E-Mail es válido</TextBody>
                                        </div>
                                    </div>
                                </Margin>
                            </Column>
                        </Row>
                    )}
                </div>
                <div className="button-container">
                    <Row>
                        <Column className="buttons-email">
                            <Row>
                                <Column xs={4} sm={8} md={12} lg={12}>
                                    <Margin
                                        xs={[0, 0, 24, 0]}
                                        sm={[0, 0, 24, 0]}
                                        md={[0, 0, 24, 0]}
                                        lg={[0, 0, 24, 0]}
                                    >
                                        <PrimaryButton
                                            onClick={validateEmail}
                                            disabled={
                                                (state.errors.email &&
                                                    state.errors.email.trim() !== "") ||
                                                state.email.length < 5
                                                    ? true
                                                    : false
                                            }
                                        >
                                            Confirmar
                                        </PrimaryButton>
                                    </Margin>
                                </Column>
                            </Row>
                            <Row>
                                <Column xs={4} sm={8} md={12} lg={12}>
                                    <Margin
                                        xs={[0, 0, 12, 0]}
                                        sm={[0, 0, 12, 0]}
                                        md={[0, 0, 12, 0]}
                                        lg={[0, 0, 12, 0]}
                                    >
                                        <SecondaryButton
                                            onClick={onClose}
                                        >
                                            Volver
                                        </SecondaryButton>
                                    </Margin>
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                </div>
            </ModalOverlay>
        </Fragment>
    );
};

export default ModalEmail;
